<template>
  <div class="headerBox">
    <header>
      <div class="logo">
        <a href="/"><img src="../../assets/logo.png" alt="" /></a>
      </div>
      <div class="nav">
        <el-menu
          router
          :default-active="$route.path"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          active-text-color="#003448"
          text-color="#9b9b9b"
        >
          <template v-for="item in menus">
            <el-submenu
              :index="$commonjs.routeFormat(item.menuFather)"
              :key="item.index"
              v-if="item.menuChild && item.menuChild.length"
            >
              <span slot="title">{{ item.menuFather }}</span>
              <div style="padding: 0 20px" v-if="menuItemMode == 'horizontal'">
                <el-menu-item
                  class="nav-menu-item"
                  :index="'/' + $commonjs.routeFormat(sub)"
                  v-for="(sub, index) in item.menuChild"
                  :key="index"
                  >{{ sub }}</el-menu-item
                >
              </div>
              <el-menu-item
                :index="'/' + $commonjs.routeFormat(sub)"
                v-for="(sub, index) in item.menuChild"
                :key="index"
                v-else
                >{{ sub }}</el-menu-item
              >
            </el-submenu>
            <el-menu-item
              :index="'/' + $commonjs.routeFormat(item.menuFather)"
              :key="item.index"
              v-else
              >{{ item.menuFather }}</el-menu-item
            >
          </template>
        </el-menu>
      </div>
      <div class="head">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link" style="color: #5582a0">
            {{ $store.state.username }}
            <em class="el-icon-caret-bottom"></em>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="resetPasswrd"
              >Change Password</el-dropdown-item
            > -->
            <el-dropdown-item divided command="logOut"
              >Log Out</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        title="Reset Password"
        :visible.sync="dialogFormVisible"
        width="500px"
        :modal-append-to-body="false"
      >
        <el-form
          :model="formPassword"
          :rules="rulesPassword"
          ref="formPassword"
        >
          <el-form-item
            label="Old Password"
            :label-width="formLabelWidth"
            prop="oldPassword"
          >
            <el-input
              v-model="formPassword.oldPassword"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item
            label="New Password"
            :label-width="formLabelWidth"
            prop="newPassword"
            class="newPassword"
          >
            <el-input
              v-model="formPassword.newPassword"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Confirm Password"
            :label-width="formLabelWidth"
            prop="confirmPassword"
          >
            <el-input
              v-model="formPassword.confirmPassword"
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">Cancel</el-button>
          <el-button type="primary" @click="submitPassword('formPassword')"
            >Confirm</el-button
          >
        </div>
      </el-dialog>
    </header>
  </div>
</template>

<script>
import { apiResetPassword, apiUserLogout } from "@/request/api";
import UploadImage from "@/components/common/upload/Image";
export default {
  name: "Header",
  components: {
    "upload-image": UploadImage,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value !== this.formPassword.newPassword) {
        callback(new Error("New password and confirm password inconsistent"));
      } else {
        callback();
      }
    };
    var pwdValidator = (rule, value, callback) => {
      let pattern = this.$commonjs.passwordReg;
      let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      if (pattern.test(value)) {
        if (reg.test(value)) {
          callback(new Error("Password can not contain Chinese"));
        } else {
          callback();
        }
      } else {
        callback(
          new Error(
            "Password length must be 8-20 and contain uppercase, lowercase, numeric and special characters"
          )
        );
      }
    };
    return {
      menuItemMode: "horizontal", // horizontal/vertical
      dialogFormVisible: false,
      formLabelWidth: "136px",
      formPassword: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      rulesPassword: {
        oldPassword: [
          { required: true, message: "The Old Password cannot be empty" },
        ],
        newPassword: [
          { required: true, message: "The New Password cannot be empty" },
          { validator: pwdValidator },
        ],
        confirmPassword: [
          { required: true, message: "The Confirm Password cannot be empty" },
          { validator: validatePass },
        ],
      },
      menus: this.$store.state.menus,
      formCheckIn: {
        roiNo: "",
      },
      importFileActionURL: this.baseURL + "/cmsInterface/import/file",
      headers: {
        Authorization: this.bearer + this.$store.state.token,
      },
      formImport: {
        balotingType: "",
        propertyNames: "",
        propertyId: "",
        roundId: "",
        roundNames: "",
        fileList: [],
        file: "",
      },
      formImportConfig: {
        propertyNames: [],
        propertyCodes: [],
        roundCodes: [],
        roundNames: [],
      },
      rulesImport: {
        propertyId: [
          { required: true, message: "The Property can not be empty!" },
        ],
        roundId: [{ required: true, message: "The Round can not be empty!" }],
        balotingType: [
          { required: true, message: "The Baloting Type can not be empty!" },
        ],
        file: [{ required: true, message: "The File can not be empty!" }],
      },
      rulesCheckIn: {
        roiNo: [{ required: true, message: "ROI Number cannot be empty" }],
      },
      dialogCheckIn: false,
      dialogImport: false,
      cacheROI: "",
      checkInStatus: 0,
      errorMsg: "",
    };
  },
  methods: {


    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleCommand(command) {
      if (command == "resetPasswrd") {
        this.dialogFormVisible = true;
        if (
          this.formPassword.old ||
          this.formPassword.new ||
          this.formPassword.confirm
        ) {
          this.$refs["formPassword"].clearValidate();
          this.$refs["formPassword"].resetFields();
        }
      }
      if (command == "logOut") {
        apiUserLogout().then((res) => {
          this.$commonjs.handleRes(this, res, () => {
            this.$message.success("Logout successful!");
            this.$store.dispatch("UserLogout");
            this.$router.push("/login");
          });
        });
        this.$msal
          .signOut()
          .then(() => {
            // 注销成功后的处理逻辑
          })
          .catch((error) => {
            alert("error2");
            // 处理注销错误
            console.error(error);
          });

        // this.$message.success("Logout successful!");
        // this.$store.dispatch("UserLogout");
        // this.$router.push("/login");
      }
    },
    LoginValidate(name, password, callback) {
      apiLoginValidate(password).then((res) => {
        if (res.status == 200) {
          if (res.data.status == "00") {
            // this.formPassword[name] = res.data.payload[0];
            callback(res.data.payload[0]);
          } else {
            this.$message.error(res.data.msg);
          }
        } else {
          this.$message.error(res.statusText);
        }
      });
    },
    submitPassword(formPassword) {
      this.$refs[formPassword].validate((valid) => {
        if (valid) {
          var that = this;
          var oldPassword = this.$encryptedRSAOAEP(
            that.formPassword.oldPassword
          );
          var newPassword = this.$encryptedRSAOAEP(
            that.formPassword.newPassword
          );
          apiResetPassword({
            oldPwd: oldPassword,
            newPwd: newPassword,
          }).then((res) => {
            that.$commonjs.handleRes(that, res, () => {
              that.$message.success("Password is updated");
              that.dialogFormVisible = false;
              that.$store.dispatch("UserLogout");
              that.$router.push("/login");
            });
          });
        } else {
          return false;
        }
      });
    },
  },
  created: function () {
    this.$emit("header", true);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
  height: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #e6ebee;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  background: #fff;
  max-width: 1780px;
  margin: 0 auto;
  min-width: 1120px;
}
.logo {
  font-size: 0;
  display: flex;
  align-items: center;
}
.logo img {
  height: 42px;
}
.nav .el-menu.el-menu--horizontal {
  border-bottom: none;
}
.nav .el-menu {
  background: #f5f7f7;
}
.nav .el-menu a {
  display: block;
}
.nav .el-menu--horizontal > .el-menu-item,
.nav .el-menu--horizontal > .el-submenu >>> .el-submenu__title {
  background: #fff !important;
}
.nav .el-menu--horizontal > .el-menu-item,
.nav .el-menu--horizontal > .el-submenu >>> .el-submenu__title {
  height: 60px;
  line-height: 60px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.15s ease, background-color 0.15s ease;
}
.nav .el-menu--horizontal > .el-menu-item.is-active {
  font-weight: 700;
  border-bottom: 3px solid #003448;
}
.nav .el-menu--horizontal > .el-menu-item:not(.is-active):hover,
.nav .el-menu--horizontal > .el-submenu:hover >>> .el-submenu__title {
  background: #f0f5f6 !important;
  color: #003448 !important;
}
.nav-menu-item {
  /* display: inline-block; */
  /* width: 200px; */
  padding: 0 !important;
}
.head {
  display: flex;
  align-items: center;
  height: 60px;
  padding-left: 24px;
}
.head .el-dropdown-selfdefine {
  line-height: 60px;
}
.head .el-dropdown-link {
  display: flex;
  align-items: center;
  column-gap: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.head .el-avatar {
  width: 30px;
  height: 30px;
  line-height: 30px;
  vertical-align: middle;
}
.head .el-icon-arrow-down {
  color: #909399;
}
.head .el-dropdown-link:hover .el-avatar {
  background: #9ea1a3;
}
.head .el-dropdown-link:hover .el-icon-arrow-down {
  color: #303133;
}
.svg {
  height: 14px;
}

.uploadFileButton {
  position: relative;
}

.uploadFileFormItem {
  text-align: left;
}
.nav {
  /* margin-right: 60px; */
  margin-left: auto;
}
.headerBox {
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.newPassword {
  margin: 35px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue